<style scoped>
.timesheet {
	background-color: #FAFAFA;
	border-radius: 4px;
	max-width: 500px;
	margin: 5px;
}

.timesheet_top {
	background-color: #00AAFD;
	border-radius: 4px 4px 0px 0px;
	width: 100%;
	height: 5px;
}

.timesheet_content {
	padding-left: 15px;	
	padding-right: 15px;	
	padding-top: 5px;	
	padding-bottom: 5px;	
}
</style>

<template>

	<div class="timesheet">
		<div class="timesheet_top"/>
		<v-row 
			class="timesheet_content"
			no-gutters
			v-if="errormsg != ''"
		>
			<v-col col="12" >
				<v-alert type="error">{{
					errormsg
				}}</v-alert>
			</v-col>
		</v-row>

		<v-row 
			class="timesheet_content"
			no-gutters
			v-if="!loading"
		>
			<v-col cols="12" class="mt-1 mx-2">
				<div class="text-body1 font-weight-bold text-truncate">
					{{ timesheet.job.code }}
				</div>
			</v-col>

			<v-col cols="12" class="mx-2 mb-1">
				<div class="text-md-caption text-sm-body2">
					{{ timesheet.job.display_name }}
				</div>
			</v-col>

			<v-col cols="12" class="mx-2 mt-1" v-if="timesheet.task">
				<div class="text-md-caption text-sm-body2 text-truncate">
					Task:     {{ timesheet.task.display_name }}
				</div>
			</v-col>

			<v-col cols="12" class="mx-2 mb-2">
				<div class="text-md-caption text-sm-body2 text-truncate">
					Kind:     {{ timesheet.kind.display_name }}
				</div>
			</v-col>
		</v-row>

		<v-budget-used :used="budget_used"/>

		<v-row 
			class="timesheet_content"
			no-gutters
			v-if="!loading"
		>
			<v-col cols="6" class="text-sm-caption text-md-body2 text-left text-truncate">
				Logged: {{ format_duration(timesheet.duration) }}
			</v-col>
			<v-col cols="6" class="text-sm-caption text-md-body2 text-right text-truncate">
				Budget: {{ budget  }}
			</v-col>

			<v-col cols="12" class="px-1 mt-2">
				<v-jb-date
					label="Date"
					v-model="timesheet.date"
					class="mb-1"
				/>
			</v-col>

			<v-col cols="12" sm="6" class="mt-3 px-0 pr-md-2">
				<div class="text-caption">Hours</div>
				<number-input v-model="timesheet.hours" :min="0" :max="23" controls center size="medium"/>
			</v-col>

			<v-col cols="12" sm="6" class="mt-3 px-0 pl-md-2">
				<div class="text-caption">Minutes</div>
				<number-input v-model="timesheet.minutes" :min="0" :max="59" controls center size="medium"/>
			</v-col>

			<v-col cols="12" class="my-3" v-if="timesheet.task">
				<v-task-status 
					v-for="disp_status in filtered_task_statusses" 
					v-bind:key="disp_status.id" 
					:status="disp_status"
					:is_pressed="timesheet.task.status_id == disp_status.id"
					@click="timesheet.task.status_id = disp_status.id"
				/>
				<div style="clear: left"></div>
			</v-col>

			<v-col cols="12">
				<v-text-field
					placeholder="Enter Timesheet description here..."
					v-model="timesheet.notes" 
					class="notes"
					outlined
				/>

				<!-- <div style="display:flex;flex-direction: column;flex-grow: 1;">
					<textarea
						placeholder="Enter Timesheet description here..."
						v-model="timesheet.notes"
						class="notes"
					></textarea>
				</div> -->

			</v-col>

			<v-col cols="12" class="my-1 pb-6 text-center">
				<v-btn outlined color="#888888" @click="cancel()" class="mr-2">Cancel</v-btn>
				<v-btn depressed color="#C4C4C4" class="mr-2 grey--text text--lighten-5" @click.stop="delete_timesheet()">DELETE</v-btn>
				<v-btn color="#00AAFD" :disabled="!can_save" @click="save()" class="white--text">Save</v-btn>
			</v-col>
		</v-row>

		<v-row 
			class="timesheet_content"
			no-gutters
			v-if="loading"
		>
			<v-col col="12">
				<v-skeleton-loader
					type="list-item-avatar-two-line"
					width="100%"
				></v-skeleton-loader>
			</v-col>
		</v-row>
	</div>
</template>

<script>
// models
import Timesheet from "@/models/timesheet"
import Task from "@/models/task"

// components
import task_status from "@/components/tasks/task_status"
import jb_date from "@/components/controls/jbdate";
import budget_used from "@/components/tasks/budget_used"

// mixins
import { dateMixin } from "@/mixins/misc/dateMixin"
import { metaMixin } from "@/mixins/tasks/metaMixin";
import { durationMixin } from "@/mixins/misc/durationMixin"

export default {
	mixins: [ dateMixin, metaMixin, durationMixin ],
	data() {
		return {
			errormsg: '',
			loading: false,
			saving: false,
			timesheet: new Timesheet(),
		}
	},
	components: {
		'v-task-status': task_status,
		'v-jb-date': jb_date,
		'v-budget-used': budget_used,
	},
	created() {
		this.load(this.$route.params.id)
	},	
	watch: {
		'$route.params.id': function(id) {
			this.$nextTick(() => {
				this.load(id);
			});
		}
	},
	computed: {
		can_save() {
			if (this.saving) {
				return false;
			}
			if (this.hours == 0 && this.minutes == 0) {
				return false;
			}

			return true;
		},
		budget() {
			if (this.timesheet.task.id == 0) {
				return 'n/a';
			} else {
				return this.format_duration(this.timesheet.task.budget);
			}
		},
		budget_used() {
			if (this.timesheet.task.id == 0) {
				return 0.0
			} else if (this.timesheet.task.budget_value > 0.0) {
				// TODO enhance this to take into account our value change
				return 100.0 * this.timesheet.value / this.timesheet.task.budget_value;
			} else if (this.timesheet.task.budget > 0) {
				// TODO enhance this to take into account our duration change
				return 100.0 * this.timesheet.duration / this.timesheet.task.budget;
			}
			return 0.0;
		}
	},
	methods: {
		load(timesheet_id) {
			// reload our meta data just in case it changed...
			this.load_meta_data();

			let self = this; // make sure we can access this inside of our promisses
			this.loading = true;
			this.errormsg = '';

			this.timesheet.load(timesheet_id)
				.then(function() {
					// TODO add checks to see if we are allowed to edit this timesheet

					self.$store.commit("push_breadcrumb", {
						exact: true,
						text: 'Timesheet ' + self.timesheet.id,
						to: self.$route.path
					});					
				})
				.catch(function(errormsg) {
					self.errormsg = errormsg;
				})
				.finally(function() {
					self.loading = false;
				});
		},
		save() {
			let self = this;
			this.errormsg = '';
			this.saving = true;

			// remember this, our save will reset them
			let task_id = 0;
			let status_id = 0;
			if (self.timesheet.task) {
				task_id = self.timesheet.task.id;
				status_id = self.timesheet.task.status_id;
			}

			this.timesheet.update()
				.then(function() {
					if (task_id == 0) {
						// we are done, where do we go to? back to tasks?
						self.$router.push({ name: "My Timesheets"});
						self.saving = false;						
					} else {
						let task = new Task;

						task.change_task_status(task_id, status_id)
							.then(function() {
								// we are done, where do we go to? back to tasks?
								self.$router.push({ name: "My Timesheets"});
								self.saving = false;
							})
							.catch(function(reason) {
								// TODO at this point our timesheet was created, just the status update failed
								// this needs to change to a message and still return to the my timesheets window...
								self.errormsg = reason;
								self.saving = false;
							})

					}
				})
				.catch(function(errormsg) {
					self.errormsg = errormsg;
					self.saving = false;
				});
		},
		delete_timesheet() {
			let self = this;
			this.errormsg = '';

			this.timesheet.delete()
				.then(function() {
					// we are done, where do we go to? back to tasks?
					self.$router.push({ name: "My Timesheets"});
					self.saving = false;						
				})
				.catch(function(errormsg) {
					self.errormsg = errormsg;
					self.saving = false;
				});
		},
		cancel() {
			// TODO change this so we go back on our breadcrumb..
			this.$router.push({ name: "My Timesheets"});
		}
	}
}
</script>
